import { SocialNetworkIdentifiers } from './types'

/**
 * Maps social network identifier to icon name
 */
export const getSocialNetworkIcon = (networkId: string): string => {
  switch (networkId) {
    case SocialNetworkIdentifiers.FACEBOOK:
      return 'facebook'
    case SocialNetworkIdentifiers.LINKEDIN:
      return 'linkedIn'
    case SocialNetworkIdentifiers.TWITTER:
      return 'x'
    case SocialNetworkIdentifiers.XING:
      return 'xing'
    case SocialNetworkIdentifiers.YOUTUBE:
      return 'youtube'
    default:
      return 'link' // Default icon for unknown networks
  }
}

/**
 * Returns the default URL for a social network
 */
export const getDefaultSocialNetworkUrl = (networkId: string): string => {
  switch (networkId) {
    case SocialNetworkIdentifiers.FACEBOOK:
      return 'https://facebook.com'
    case SocialNetworkIdentifiers.LINKEDIN:
      return 'https://linkedin.com'
    case SocialNetworkIdentifiers.TWITTER:
      return 'https://x.com'
    case SocialNetworkIdentifiers.YOUTUBE:
      return 'https://youtube.com'
    case SocialNetworkIdentifiers.XING:
      return 'https://xing.com'
    default:
      return '#'
  }
}
